import Vue from 'vue'
import Vuex from 'vuex';
import firebase from "./../firebase";


let db = firebase.firestore();
let auth = firebase.auth();

Vue.use(Vuex)

let store = new Vuex.Store({
    state: {
        user : null,
        positions: [],
    },
    getters: {
        getOrderedPositions: state => {
            state.positions.sort( (a,b) => {
                return a.order - b.order;
            });

            state.positions.forEach((p) => {
                p.messages.sort((a,b) => {
                    return a.order - b.order;
                });
            })

            return state.positions;
        },
        getUser: state => {
            return state.user;
        }
    },
    mutations: {
        bumpUpPosition(state, index) {
            state.positions = bumpUp(state.positions, index);
        },
        bumpDownPosition(state, index) {
            state.positions = bumpDown(state.positions, index);
        },
        deletePosition(state, index) {
            deletePosition(state.positions, index);
        },
        createNewPosition(state, object) {
            state.positions = addNewPosition(state.positions, object);
        },
        updatePosition(state, object) {
            state.positions = updatePosition(state.positions, object.position, object.obj);
        },
        setUser(state, user) {
            state.user = user;
        },
        setPositions(state, positions) {
            state.positions = positions.positions;
        }
    },
    actions: {
        syncToFirestore({state}) {
            return writeToFirestore({
                positions : state.positions
            });
        },
        signIn({commit}, credentials) {
            return auth.setPersistence(firebase.auth.Auth.Persistence.SESSION).then( () => {
                return auth.signInWithEmailAndPassword(credentials.username, credentials.password)
                .then( u => {
                    commit('setUser', u);
                    return u;
                });
            })
        },
        loadFromFirestore({commit}) {
            loadFromFireStore().then((doc) => {
                if (doc.exists) {
                    console.log("Document data:", doc.data());
                    commit('setPositions', doc.data());
                }
            }).catch((error) => {
                console.log("Error getting positions", error);
            });
        }
    },
    modules: {}
});

function bumpUp(list, selectedItemIndex) {
    if (selectedItemIndex < 0) {
        return list;
    }

    if (selectedItemIndex === 0) {
        return list;
    }

    let selectedItem = null;
    let selectedItem2 = null;

    list.forEach((item, index) => {
        if (item.order === selectedItemIndex) {
            selectedItem = index;
        }
        if (item.order === selectedItemIndex - 1) {
            selectedItem2 = index;
        }
    })

    list[selectedItem].order -= 1;
    list[selectedItem2].order += 1;

    return list;
}

function bumpDown(list, selectedItemIndex) {
    if (selectedItemIndex > list.length - 1) {
        return list;
    }

    if (selectedItemIndex === list.length - 1) {
        return list;
    }

    let selectedItem = null;
    let selectedItem2 = null;

    list.forEach((item, index) => {
        if (item.order === selectedItemIndex) {
            selectedItem = index;
        }
        if (item.order === selectedItemIndex + 1) {
            selectedItem2 = index;
        }
    })

    list[selectedItem].order += 1;
    list[selectedItem2].order -= 1;

    return list;
}

function deletePosition(list, selectedItemIndex) {
    let endOfList = list.length - 1;
    for (let x = selectedItemIndex; x <= endOfList; x++) {
        list = bumpDown(list, x);
    }

    list.splice(selectedItemIndex, 1);
}

function addNewPosition(list, object) {
    let newObj = {
        title : object.title,
        summary : object.summary,
        symbol: object.symbol,
        order : list.length,
        positionCost: object.positionCost,
        messages : [],
    }

    list.push(newObj);

    return list;
}

function updatePosition(list, position, object) {
    let o = list[position];
    o.symbol = object.symbol;
    o.title = object.title;
    o.summary = object.summary;
    o.positionCost = object.positionCost;

    list[position] = o;

    return list;
}

function writeToFirestore(state) {
    return db.collection("positions").doc("hello").set(state);
}
function loadFromFireStore() {
    //let docRef = db.collection("positions").doc("hello");
    return new Promise(((resolve, reject) => {
        resolve([]);
    }))
}

store.dispatch('loadFromFirestore');

auth.onAuthStateChanged((user) => {
    if (user) {
        store.commit('setUser', user);
    }
});

export default store;
